export const ApiUrl = "https://cms.msscc.in/api";

export const MssccUrl = "https://region.msscc.in/api";

